import { Terminal, Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { secureOpenUrl } from '@/utils/linkValidation';

const TTVPSPricingSection = () => {
  // Convert USD to TTD (1 USD = 6.75 TTD)
  const linuxVPS = [
    {
      name: "VPS Linux Start",
      cpu: "1 vCore",
      ram: "1 GB RAM", 
      port: "1 Port",
      price: "$33.75 TTD",
      usdPrice: "$5 USD",
      link: "https://acc.nexx.net/index.php?rp=/store/vps-linux"
    },
    {
      name: "VPS Linux Basic",
      cpu: "1 vCore", 
      ram: "2 GB RAM",
      port: "1 Port", 
      price: "$67.50 TTD",
      usdPrice: "$10 USD",
      link: "https://acc.nexx.net/index.php?rp=/store/vps-linux"
    },
    {
      name: "VPS Linux Pro",
      cpu: "2 vCore",
      ram: "4 GB RAM",
      port: "1 Port",
      price: "$135.00 TTD", 
      usdPrice: "$20 USD",
      link: "https://acc.nexx.net/index.php?rp=/store/vps-linux"
    },
    {
      name: "VPS Linux Max",
      cpu: "2 vCore",
      ram: "8 GB RAM", 
      port: "1 Port",
      price: "$168.75 TTD",
      usdPrice: "$25 USD", 
      link: "https://acc.nexx.net/index.php?rp=/store/vps-linux"
    }
  ];

  const windowsVPS = [
    {
      name: "VPS Windows Start", 
      cpu: "2 vCore",
      ram: "4 GB RAM",
      port: "1 Port",
      price: "$67.50 TTD",
      usdPrice: "$10 USD",
      link: "https://acc.nexx.net/index.php?rp=/store/vps-windows"
    },
    {
      name: "VPS Windows Basic",
      cpu: "2 vCore", 
      ram: "6 GB RAM",
      port: "1 Port",
      price: "$135.00 TTD", 
      usdPrice: "$20 USD",
      link: "https://acc.nexx.net/index.php?rp=/store/vps-windows"
    },
    {
      name: "VPS Windows Pro",
      cpu: "4 vCore",
      ram: "8 GB RAM", 
      port: "1 Port", 
      price: "$202.50 TTD",
      usdPrice: "$30 USD",
      link: "https://acc.nexx.net/index.php?rp=/store/vps-windows"
    },
    {
      name: "VPS Windows Max",
      cpu: "4 vCore",
      ram: "16 GB RAM",
      port: "1 Port",
      price: "$270.00 TTD",
      usdPrice: "$40 USD", 
      link: "https://acc.nexx.net/index.php?rp=/store/vps-windows"
    }
  ];

  const TTVPSCard = ({ vps, index }: { vps: any, index: number }) => (
    <div 
      className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-fade-in"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <h3 className="text-lg font-bold text-gray-900 mb-4">{vps.name}</h3>
      
      <div className="space-y-2 mb-6">
        <div className="flex justify-between">
          <span className="text-gray-600">CPU:</span>
          <span className="font-semibold">{vps.cpu}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">RAM:</span>
          <span className="font-semibold">{vps.ram}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600">Port:</span>
          <span className="font-semibold">{vps.port}</span>
        </div>
      </div>

      <div className="text-center mb-6">
        <div className="text-2xl font-bold text-red-600 mb-1">
          🇹🇹 {vps.price}
        </div>
        <div className="text-sm text-gray-500">
          (was {vps.usdPrice})
        </div>
      </div>

      <Button 
        onClick={() => secureOpenUrl(vps.link)}
        className="w-full bg-red-600 hover:bg-red-700 text-white"
      >
        Order Now - Pay in TTD
      </Button>
    </div>
  );

  return (
    <section className="py-12 bg-white/50 rounded-xl mb-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            VPS Servers - Trinidad & Tobago Pricing
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Professional VPS hosting with TTD pricing. No forex headaches - pay in your local currency.
          </p>
        </div>

        {/* Linux VPS Section */}
        <div className="mb-12">
          <div className="flex items-center justify-center mb-6">
            <Terminal className="h-6 w-6 text-red-600 mr-2" />
            <h3 className="text-2xl font-bold text-gray-900">Linux VPS</h3>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {linuxVPS.map((vps, index) => (
              <TTVPSCard key={index} vps={vps} index={index} />
            ))}
          </div>
        </div>

        {/* Windows VPS Section */}
        <div>
          <div className="flex items-center justify-center mb-6">
            <Monitor className="h-6 w-6 text-red-600 mr-2" />
            <h3 className="text-2xl font-bold text-gray-900">Windows VPS</h3>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {windowsVPS.map((vps, index) => (
              <TTVPSCard key={index} vps={vps} index={index} />
            ))}
          </div>
        </div>

        <div className="text-center mt-8 p-4 bg-red-50 rounded-lg border border-red-200">
          <p className="text-red-800 font-semibold">
            💡 Contact us to pay in Trinidad & Tobago Dollars - No USD required!
          </p>
        </div>
      </div>
    </section>
  );
};

export default TTVPSPricingSection;